import React from 'react'
import ComingSoon from '../../singles/coming-soon/Coming-soon'
export default function How() {
  return (
    <div>
        <ComingSoon />
    </div>
  )
}
